import { createI18n } from 'vue-i18n';
import messages, { loadLocaleMessages } from 'dashboard/i18n';

// Shared i18n instance for the dashboard app. Exported so that plain JS
// helpers (outside Vue components) can translate strings via `i18n.global.t`.
const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  messages,
});

// Troca o locale ativo, carregando o dicionário sob demanda quando ainda não
// está registrado (só en/pt_BR vêm no bundle inicial). Locale vazio é no-op.
export const setI18nLocale = async locale => {
  if (!locale) return;

  if (!i18n.global.availableLocales.includes(locale)) {
    i18n.global.setLocaleMessage(locale, await loadLocaleMessages(locale));
  }
  i18n.global.locale.value = locale;
};

export default i18n;
